import React from "react";

const TempleGridValues = () => {
  return <div>bible verses</div>;
};

export default TempleGridValues;
